export const packagingInitialState = {
  JuiceFlavor: {
    value: '',
    label: 'Fruit Type',
  },
  otherFlavor: '',
  ContainerType: {
    value: '',
    label: 'Container Size',
  },
  VitaminCCertification: false,
  OneHundredPercentJuiceCertification: false,
  FrontLabelCertification: false,
  JuiceType: 'Bottled',
}

export const juiceTypeOptions = ['Bottled', 'Concentrate']

export const concentrateJuiceInitialState = {
  category: '54',
  subCategory: '',
  ...packagingInitialState,
}

export const bottleJuiceInitialState = {
  category: '54',
  subCategory: '002',
  ...packagingInitialState,
}

export const flavorOptions = [
  {
    value: '',
    label: 'Juice Flavor',
    isDisabled: true,
  },
  { value: 'Apple', label: 'Apple' },
  { value: 'Cranberry', label: 'Cranberry' },
  { value: 'Grape', label: 'Grape' },
  { value: 'Grapefruit', label: 'Grapefruit' },
  { value: 'Grapefruit - White', label: 'Grapefruit - White' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Pineapple', label: 'Pineapple' },
  { value: 'Prune', label: 'Prune' },
  { value: 'Tomato', label: 'Tomato' },
  { value: 'Vegetable', label: 'Vegetable' },
  { value: 'Blend', label: 'Blend' },
]

export const bottledContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '64 oz shelf-stable only', label: '64 oz shelf-stable only' },
]

export const concentrateContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: '11.5 oz concentrate',
    label: '11.5 oz concentrate',
    subCategory: '101',
  },
  {
    value: '12 oz concentrate',
    label: '12 oz concentrate',
    subCategory: '101',
  },
  {
    value: '16 oz concentrate',
    label: '16 oz concentrate',
    subCategory: '001',
  },
]
